import { render, staticRenderFns } from "./Integrator.vue?vue&type=template&id=f6716070&scoped=true"
import script from "./Integrator.vue?vue&type=script&lang=js"
export * from "./Integrator.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=f6716070&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6716070",
  null
  
)

export default component.exports